export const isExternalLink = (a, b) => {
  try {
    a = new URL(a);
    b = new URL(b);
    return a.hostname !== '' && b.hostname !== '' && a.hostname !== b.hostname;
  } catch (error) {
    return false;
  }
};
